import React from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ContactFormWrapper from '../components/ContactFormWrapper';
import { motion } from "framer-motion";
const ServicesPage = () => {
  const { t } = useTranslation();


  return (
    <>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Box sx={{ p: 3, maxWidth: '800px', margin: 'auto' }}>
          <Typography variant="h4" gutterBottom sx={{ color: '#c6a04c' }}>
            💼 {t("services.title")}
          </Typography>

          <Typography variant="body1" paragraph sx={{ color: '#c6a04c' }}>
            {t("services.intro")}
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ color: '#c6a04c' }}>
            {t("services.accounting.title")}
          </Typography>

          <List sx={{ pl: 2 }}>
            <ListItem sx={{ color: '#c6a04c' }}>- {t("services.accounting.point1")}</ListItem>
            <ListItem sx={{ color: '#c6a04c' }}>- {t("services.accounting.point2")}</ListItem>
            <ListItem sx={{ color: '#c6a04c' }}>- {t("services.accounting.point3")}</ListItem>
            <ListItem sx={{ color: '#c6a04c' }}>- {t("services.accounting.point4")}</ListItem>
            <ListItem sx={{ color: '#c6a04c' }}>- {t("services.accounting.point5")}</ListItem>
            <ListItem sx={{ color: '#c6a04c' }}>- {t("services.accounting.point6")}</ListItem>
          </List>
        </Box>

        <Box sx={{ mt: 6 }}>
          <ContactFormWrapper
            type="full"
            hideFields={['requestedServices']}
            pageName="Ekonomitjänster"
            redirectPath="/"
            showHeader={false}
          />
        </Box>
      </motion.div>
    </>
  );
};

export default ServicesPage;
